import { ISelectedFilterBody } from 'components/filter/models/TableFilterModels';
import moment from 'moment';

import { InputValues } from '../models/InputsModel';

interface IHandleInputChangeParams {
	name: string;
	value: string | number;
	setInputValue: React.Dispatch<React.SetStateAction<any>>;
}

interface IValidateEndValueParams {
	name: 'valorFinal' | 'valorInicial';
	value: string | number;
	column_type:
		| 'quantity'
		| 'currency'
		| 'date'
		| 'month'
		| 'time'
		| 'datetime'
		| 'boolean'
		| 'string';
	inputValue: InputValues;
}

interface IFindIndexByOperationParams {
	updatedForm: ISelectedFilterBody[];
	column_name: string;
	operation: string;
}

interface IAddOrUpdateItemInArrayParams {
	updatedForm: ISelectedFilterBody[];
	column_name: string;
	value_type: string;
	value: string | number | string[] | number[];
	operation: string;
	dependencia?: string;
	transform?: boolean;
}

interface IRemoveItemAtIndexParams {
	updatedForm: ISelectedFilterBody[];
	existingIndex: number;
}

export const handleInputChange = ({
	name,
	value,
	setInputValue,
}: IHandleInputChangeParams): void => {
	setInputValue((prev: React.SetStateAction<any>) => ({
		...prev,
		[name]: value,
	}));
};

export const operationMap = {
	valorInicial: 'greater_equal',
	valorFinal: 'less_equal',
	textSearch: 'in',
	boolean: 'equal',
};

export const validateEndValue = ({
	name,
	value,
	column_type,
	inputValue,
}: IValidateEndValueParams): boolean => {
	if (name === 'valorInicial') {
		if (column_type === 'date' && inputValue.valorFinal !== '') {
			const initialTime = moment(value, 'YYYY-MM-DD');
			const endTime = moment(inputValue.valorFinal, 'YYYY-MM-DD');
			return initialTime.isAfter(endTime);
		}
		if (column_type === 'month' && inputValue.valorFinal !== '') {
			const initialTime = moment(value, 'YYYY-MM');
			const endTime = moment(inputValue.valorFinal, 'YYYY-MM');
			return initialTime.isAfter(endTime);
		}
		if (column_type === 'datetime' && inputValue.valorFinal !== '') {
			const initialTime = moment(value, 'YYYY-MM-DD HH:mm');
			const endTime = moment(inputValue.valorFinal, 'YYYY-MM-DD HH:mm');
			return initialTime.isAfter(endTime);
		}
		if (inputValue.valorFinal !== '') {
			return +value > +inputValue.valorFinal;
		}

		return false;
	} else {
		if (value === '') {
			return false; // Se o campo estiver vazio, não entre na validação
		}

		if (column_type === 'date') {
			if (inputValue.valorInicial === '') {
				return false;
			}
			const initialTime = moment(inputValue.valorInicial, 'YYYY-MM-DD');
			const endTime = moment(value, 'YYYY-MM-DD');
			return (
				!endTime.isAfter(initialTime) && !endTime.isSame(initialTime)
			);
		}
		if (column_type === 'month') {
			if (inputValue.valorInicial === '') {
				return false;
			}
			const initialTime = moment(inputValue.valorInicial, 'YYYY-MM');
			const endTime = moment(value, 'YYYY-MM');
			return (
				!endTime.isAfter(initialTime) && !endTime.isSame(initialTime)
			);
		}
		if (column_type === 'datetime') {
			if (inputValue.valorInicial === '') {
				return false;
			}
			const initialTime = moment(
				inputValue.valorInicial,
				'YYYY-MM-DD HH:mm'
			);
			const endTime = moment(value, 'YYYY-MM-DD HH:mm');
			return (
				!endTime.isAfter(initialTime) && !endTime.isSame(initialTime)
			);
		}

		if (inputValue.valorInicial === '') {
			return false;
		}

		return +value < +inputValue.valorInicial;
	}
};

export const findIndexByOperation = ({
	updatedForm,
	column_name,
	operation,
}: IFindIndexByOperationParams): number => {
	return updatedForm.findIndex(
		item => item.column_name === column_name && item.operation === operation
	);
};

export const addOrUpdateItemInArray = ({
	updatedForm,
	column_name,
	value_type,
	value,
	operation,
	transform,
}: IAddOrUpdateItemInArrayParams): ISelectedFilterBody[] => {
	const existingIndex = findIndexByOperation({
		updatedForm,
		column_name,
		operation,
	});

	if (existingIndex !== -1) {
		// Se já existir, atualize o objeto existente com o valor
		updatedForm[existingIndex].values = value;
	} else {
		// Se não existir, crie um novo objeto com o valor
		const newItem = {
			column_name: column_name,
			value_type: value_type,
			values: value,
			operation: operation,
			transform,
		};
		updatedForm.push(newItem);
	}

	return updatedForm;
};

export const removeItemAtIndex = ({
	updatedForm,
	existingIndex,
}: IRemoveItemAtIndexParams): ISelectedFilterBody[] | [] => {
	return updatedForm.filter((option, idx) => idx !== existingIndex);
};
